import styled from "styled-components";
import { Link } from "gatsby";
import WindowedSelect from "react-windowed-select";
import React from "react";

export const TopHeaderGrid = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  padding-top: 5px;
  flex-direction: column-reverse;
  @media (min-width: 768px) {
    margin: 0 -10px;
    padding-top: 10px;
  }
  @media (min-width: 992px) {
    margin: 0 -15px;
    padding-top: 10px;
    flex-direction: row;
  }
  @media (min-width: 1200px) {
    margin: 0 -20px;
    padding-top: 15px;
  }
  @media (min-width: 1600px) {
    margin: 0 -45px;
    padding-top: 20px;
  }
`;
export const TopLeftHeader = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width: 768px) {
    padding: 0 10px;
  }
  @media (min-width: 992px) {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
    padding: 0 15px;
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (min-width: 1600px) {
    padding: 0 45px;
  }
`;
export const TopRightHeader = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width: 768px) {
    padding: 0 10px;
  }
  @media (min-width: 992px) {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
    padding: 0 15px;
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (min-width: 1600px) {
    padding: 0 45px;
  }
`;
export const StateHero = styled.div`
  position: relative;
  margin-bottom: 30px;
`;
export const StateBanner = styled.div`
  overflow: hidden;
  border-radius: 10px;
`;
export const StateMap = styled.div`
  position: absolute;
  bottom: 15px;
  right: 5px;
`;
export const PopularSize = styled.div`
  border: 1px solid #babfdf;
  background-color: #eef0fd;
  border-radius: 10px;
  margin-bottom: 30px;
  padding: 20px;
  @media (min-width: 768px) {
    padding: 30px;
  }
`;
export const PopularAction = styled.div`
  a{display:inline-flex;}
  margin-bottom: 30px;
  /* .btn{
    .icon{
      background-color:#E9242A;      
      margin:5px;
      padding:5px 12px !important;
      @media(min-width:576px){
        padding:5px 20px !important;
      }
      border-radius:25px;
      @media(min-width:1600px){
        border-radius:30px;
      }
      > svg{
        fill:#fff;
        width:24px;
        @media(min-width:576px){
          width:30px;
        }
      }
    }
    font-size:14px;
    line-height: 24px;
		@media(min-width:576px){
      font-size:16px;
      line-height: 30px;
		}
    @media (min-width: 1200px) {
      .text {
        font-size: 18px;
        line-height: 28px;
      }
    }
    &:hover{
      .icon{
        background-color:#373636;
      }
    }
  } */
`;
export const SizeTitle = styled.div`
  font-weight: 600;
  margin-bottom: 10px;
  font-size: 16px;
  line-height: 30px;
  @media (min-width: 768px) {
    font-size: 18px;
    line-height: 30px;
  }
  @media (min-width: 992px) {
    font-size: 20px;
    line-height: 30px;
  }
  @media (min-width: 1200px) {
    font-size: 24px;
    line-height: 34px;
  }
  @media (min-width: 1600px) {
    font-size: 28px;
    line-height: 38px;
  }
`;
export const ListSize = styled.div``;
export const ListItemSize = styled.div`
  .text {
    text-decoration: underline;
    font-size: 14px;
    line-height: 20px;
    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 24px;
    }
    @media (min-width: 1600px) {
      font-size: 18px;
      line-height: 28px;
    }
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    > svg {
      fill: #e9242a;
    }
    height: 20px;
    @media (min-width: 768px) {
      height: 24px;
    }
    @media (min-width: 992px) {
      height: 28px;
    }
    + .text {
      margin-left: 10px;
      @media (min-width: 768px) {
        margin-left: 15px;
      }
      @media (min-width: 1600px) {
        margin-left: 20px;
      }
    }
  }
  > a {
    display: flex;
    flex-wrap: nowrap;
    color: #373636;
    &:hover {
      color: #e9242a;
      .text {
        text-decoration: none;
      }
    }
  }
  &.list-item {
    + .list-item {
      margin-top: 15px;
    }
  }
`;
export const ListCity = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin: 0 -15px 30px -15px;
  .list-item{
    display: flex;
    flex-wrap:wrap;
    color: #373636;
    padding: 5px 15px;
    flex: 0 0 50%;
    max-width: 50%;
    @media (min-width: 768px) {
      flex: 0 0 33.33333%;
      max-width: 33.33333%;
    }
    @media (min-width: 992px) {
      flex: 0 0 20%;
      max-width: 20%;
    }
    @media (min-width: 1200px) {
      flex: 0 0 16.66666%;
      max-width: 16.66666%;
    }
    .text {
      font-size: 14px;
      line-height: 24px;
      white-space: nowrap;
      @media (min-width: 992px) {
        font-size: 16px;
        line-height: 26px;
      }
    }
    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 30px;
      + .text {
        margin-left: 15px;
      }
      > svg {
        fill: #e9242a;
      }
    }
  }
`;
export const ListCityAction = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;  
`;
export const ListState = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  margin: 0 -15px;
`;
export const ListItemState = styled(Link)`
  display: flex;
  flex-wrap: nowrap;
  color: #ccc;
  &:hover {
    color: #e9242a;
  }
  padding: 5px 15px;
  flex: 0 0 50%;
  max-width: 50%;
  @media (min-width: 576px) {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  @media (min-width: 768px) {
    flex: 0 0 20%;
    max-width: 20%;
  }
  @media (min-width: 1200px) {
    flex: 0 0 16.66666%;
    max-width: 16.66666%;
  }
  .text {
    font-size: 14px;
    line-height: 24px;
    @media (min-width: 992px) {
      font-size: 16px;
      line-height: 26px;
    }
  }
  .icon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 30px;
    + .text {
      margin-left: 15px;
    }
    > svg {
      fill: #e9242a;
    }
  }
  > a {
    color: #eee;
    &:hover {
      color: #fff;
    }
  }
`;


export const BuildGrid = styled.div`
  position: relative;
  align-items: center;
  @media (min-width: 768px) {
    display: grid;
    grid-template-columns: 1.2fr 2fr;
  }
`;
export const BuildLeftGrid = styled.div`
  position: relative;
  padding: 0;
`;
export const BuildRightGrid = styled.div`
  position: relative;
  padding: 0 15px;
  @media (min-width: 992px) {
    padding: 0 30px;
  }
  @media (min-width: 1200px) {
    padding: 0 30px;
  }
  @media (min-width: 1600px) {
    padding: 0 calc(50vw - 705px) 0 60px;
  }
`;

export const HeroBackground = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-bottom: 70px;
  height: 100%;
  @media (min-width: 768px) {
    margin-bottom: 0;
  }
  &:before {
    position: absolute;
    content: "";
    left: 0px;
    top: 50%;
    background-color: rgb(238, 240, 253);
    height: calc(100% + 60px);
    width: 100%;
    transform: translateY(-50%);
    border-radius: 0 245px 245px 0;
  }
  > img {
    position: relative;
  }
`;
export const Service = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
`;
export const ServiceLeftItem = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width: 768px) {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
`;
export const ServiceRightItem = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width: 768px) {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
`;

export const StyledWindowedSelect = styled((props) => (
  <WindowedSelect {...props} />
))`
  .css-13cymwt-control,
  .css-t3ipsp-control {
    background: #eef0fd;

    font-size: 16px;
    line-height: 28px;
    font-weight: 400;
    padding: 6px 15px;
    border-radius: 6px;
    @media (min-width: 1200px) {
      padding: 8px 25px;
      border-radius: 8px;
    }
    @media (min-width: 1600px) {
      padding: 10px 25px;
      border-radius: 10px;
    }

    &:hover,
    &:focus {
      border-color: #373636;
    }
  }
  .css-t3ipsp-control {
    box-shadow: none;
    border-color: #eef0fd;
  }
  .css-qbdosj-Input,
  .css-19bb58m {
    color: #373636;
    margin: 0;
    padding: 0;
  }
  .css-1dimb5e-singleValue {
    color: #373636;
  }

  .css-1u9des2-indicatorSeparator {
    display: none;
  }

  .css-1jqq78o-placeholder {
    color: #373636;
    font-weight: 500;
  }
  .css-1hwfws3 {
    padding: 6px 12px;
    @media (min-width: 992px) {
      padding: 8px 28px;
    }
  }

  .css-1fdsijx-ValueContainer,
  .css-hlgwow {
    padding: 0;
  }
  .css-1xc3v61-indicatorContainer,
  .css-15lsz6c-indicatorContainer {
    padding: 4px;
  }
  .css-1nmdiq5-menu {
    font-size: 16px;
    line-height: 28px;
  }
`;
